import script from "./SelectVKAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectVKAccountModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectVKAccountModal.vue?vue&type=style&index=0&id=4b8d9dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8d9dae"]])

export default __exports__